<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="searchPatient">
      <form class="w-100" @submit.stop.prevent="obtenerPaciente()">
        <div class="SearchPti">
          <strong>Id del paciente:</strong>
          <div class="inputBusqueda">
            <b-form-input
              v-model="pacienteSeleccionado"
              placeholder="Ingresa un id"
              type="text"
              v-on:keyup.enter="obtenerPaciente()"
              v-on:keypress="esNumero($event)"
              id="paciente"
            ></b-form-input>
          </div>
          <b-button variant="primary" type="submit"
            ><b-icon class="searchicon" icon="search"></b-icon
          ></b-button>
        </div>
      </form>
    </div>

    <br />
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
    <span class="tablePatients">
      <h4>Resultados de la Búsqueda</h4>
      <br />

      <b-table
        thead-tr-class="columnas"
        :items="pacienteTable"
        :fields="encabezados"
        class="parrafos"
        responsive
      >
        <template v-slot:cell(telefono)="row">
          <span v-if="row.item.telefono != null">
            {{ row.item.telefono }}
          </span>

          <span v-if="row.item.telefonoCasa != null">
            <br />
            {{ row.item.telefonoCasa }}
          </span>
          <span v-if="row.item.telefonoTrabajo != null">
            <br />
            {{ row.item.telefonoTrabajo }}
          </span>
        </template>
        <template v-slot:cell(nombre)="row">
          <router-link
             id="unificacion"
            :to="{ name: 'paciente', params: { id: row.item.id } }"
            v-if="$localStorageService.can('CA_03_menu')"
          >
            <div class="spanCien">
              <div v-if="row.item.pacienteUnificado"  v-b-tooltip.hover.top="'Es un paciente unificado.'" >

              
              <span
                 v-b-tooltip.hover.top="'Es un paciente unificado.'" 
                v-if="row.item.estatusPacienteColorDTO != null"
                :style="'color:' + row.item.estatusPacienteColorDTO.color"
              >
                {{ row.item.nombre }}
              </span>
            </div>
              <span v-else-if="row.item.estatusPacienteColorDTO != null"
                    :style="'color:' + row.item.estatusPacienteColorDTO.color"
              >
                {{ row.item.nombre }}
              </span>
              <span v-else style="color: #000000">
                {{ row.item.nombre }}
              </span>
            </div>
          </router-link>

          <!-- <b-popover style="position:fixed;" v-if="row.item.pacienteUnificado" target="unificacion" triggers="hover" placement="top">
            Es un paciente unificado.
          </b-popover> -->
        </template>
        <template v-slot:cell(adeudo)="row">
          <span style="color: red" v-if="row.item.adeudo > 0">{{
            row.item.adeudo | moneda
          }}</span>
          <span v-else>{{ row.item.adeudo | moneda }}</span>
        </template>
        <template v-slot:cell(saldo)="row">
          <span>{{ row.item.saldo | moneda }}</span>
        </template>
        <template v-slot:cell(fechaUltimaCita)="row">
          <span v-if="row.item.fechaUltimaCita != null">
            {{ row.item.fechaUltimaCita | formatoFechaCorta }}
          </span>
          <span v-else>
              No hay última cita
            </span>
        </template>
        <template v-slot:cell(clinica)="row">
            <span v-if="row.item.clinica != null">
              {{ row.item.clinica}}
            </span>
            <span v-else>
              N/A
            </span>
          </template>
        <template v-slot:cell(fechaProximaCita)="row">
          <span v-if="row.item.fechaProximaCita != null">
            {{ row.item.fechaProximaCita | formatoFechaCorta }}
          </span>
          <span v-else>
              No hay próxima cita
            </span>
        </template>
        <template v-slot:cell(planes)="row">
                <b-button size="sm" style="font-size: small" @click="onClickDetalles(row)" class="btn-info botonCentrado" >
                   <span v-if="!row.detailsShowing" title="Mostar Detalle">
                      <em class="ojo_svg icon-boton" style=" position: relative; left: 0.5px;"></em>
                   </span>
                  <span v-else title="Ocultar Detalle">
                      <em class="close_x_svg icon-boton" style=" position: relative; left: 1.5px; height: 9px !important; margin: 4px !important;"></em>
                  </span>
                </b-button>
          </template>
          <template #row-details="row">
        <b-card class="text-left" style="border-radius: 1.25rem; border-color: #1dbdd5;">
          <span v-if="row.item.planes.length > 0">
              <h6 style="font-weight: bold; color: var(--color-dentalia);">Planes del Pacient2e</h6>
               <ul v-for="(item, index) in row.item.planes" :key="item.nombre">
                <div class="d-flex justify-content-start align-items-center"> 
                  <li class="mr-1"><strong style="font-weight: bold; color: var(--color-dentalia);">{{index+1}}.- </strong>{{item.nombre}}</li>
                  <div class="text-center" v-b-tooltip.hover.topright.v-light title="Este plan no requiere herramientas de diagnóstico" v-if="buscarPlanSinHerramientas(item.id)" style="background-color: #E5E7E7; border-radius: 50px; color: #7E7E7E; padding: 2px 5px; font-weight: 600;">
                    <p class="p-0 m-0">PRESUNTIVO</p>
                  </div>
                </div>
                 
               </ul>
          </span>
          <span v-else>
             <b-alert show variant="info">No hay Planes</b-alert>
          </span>
        </b-card>
      </template>
      </b-table>
    </span>
  </div>
</template>
<script>
import miniToastr from "mini-toastr"; //ES6

export default {
  name: "PacientePorId",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    pacienteSeleccionado: null,
    encabezados: [
      { key: "id", label: "Id" },
      { key: "nombre", label: "Nombre del Paciente", sortable: true },
      { key: "fechaNacimientoCompleta", label: "Fecha de nacimiento", sortable: true },
      { key: "adeudo", label: "Adeudo", sortable: true },
      { key: "saldo", label: "Saldo", sortable: true },
      { key: "telefono", label: "Teléfono", sortable: true },
      { key: "correo", label: "Correo", sortable: true },
      { key: "fechaUltimaCita", label: "Última Cita", sortable: true },
      {key: "clinica", label: "Clínica", sortable: true},
      { key: "fechaProximaCita", label: "Próxima Cita", sortable: true },
      {key: "planes", label: "Planes", sortable: true},
    ],
    pacienteTable: [],

    pacientes: [],
    patientInput: null,
    loading: false,
    planesSinHerramientas: []
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  computed:{
     buscarPlanSinHerramientas() {
      return (planId) => {
        return this.planesSinHerramientas.find(a => a.idPlan === planId) || null;
      };
   }
  },
  methods: {

  obtenerSoloPlanesActivos(){
      const parametros = {
        idPaciente:  this.pacienteSeleccionado
      };

      this.$http.post(this.$api + "paciente/estadoPlanesPaciente", parametros)
      .then((response) => {
         const respuesta = response.data.data;
        
        const planesActivos = respuesta.filter(item => item.planActivo);
        const idPlanes = planesActivos.map(item => item.idPlan);

         this.obtenerPlanSinHerramientas(idPlanes);
           }).finally(()=> {
             this.loadercito = false;
           })
    },

     onClickDetalles(row) {
      row.toggleDetails();
      this.obtenerSoloPlanesActivos(row);
      
    },

     obtenerPlanSinHerramientas(planes){
     
     
        const parametros = {
        idPlanes: planes
      };

      this.$http.post(this.$api + "planPaciente/obtener/planesSinHerramientas", parametros)
      .then((response) => {
         const respuesta = response.data.data;
         this.planesSinHerramientas = respuesta;
           });
      
    },
    obtenerPaciente() {
      this.pacienteTable = [];
      if (
        this.pacienteSeleccionado.replace(/ /g, "") != null &&
        this.pacienteSeleccionado.replace(/ /g, "").length > 5 &&
        !isNaN(this.pacienteSeleccionado.replace(/ /g, ""))
      ) {
        const params = {
          idPaciente: this.pacienteSeleccionado.replace(/ /g, "")
        }
        let urlPacienteId =
          this.$api + "paciente/obtenerDatosPacienteId";

        this.$http
          .post(urlPacienteId, params)
          .then((response) => {
            if (response.status === 200) {
              this.pacienteTable.push(response.data.data);
            }
          })
          .catch((error) => {
            miniToastr.error("No se encontró el paciente");

            this.pacienteTable = [];
            console.error(error);
          })
          .finally(() => {});
      } else {
        this.loading = false;
      }
    },
    esNumero(e){
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[0-9]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
  },
};
</script>
<style scoped>
.SearchPti {
  width: 98%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.searchPatient {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px 0 0 0;
  border: 1px solid #ddd;
  background-color: white !important;
  padding-left: 10px;
}
.inputBusqueda {
  width: 70%;
}
.spanCien {
  width: 100% !important;
  padding-top: 5px;
  padding-bottom: 5px;
}
.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
  border-radius: 20px;
}
.icon-boton{
  -webkit-filter: brightness(0) invert(1);
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
  position: relative;
  left: 0.5px;
}
.botonCentrado{
  padding-bottom: 4px;
  padding-top: 1px;
  padding-left: 2px;
  padding-right: 4px;
}
</style>
